// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__xrxSu","col":"styles_col__Ei4GJ"};